import React from "react";
import CommunityUpdate from "../../../components/CommunityUpdate";

const CommunityNanumUpdate = () => {
  return <CommunityUpdate posttype="nanum" />;
};

export default CommunityNanumUpdate;
